export interface FileResult {
  fileUrl: string;
  fileDataUrl: string;
  thumbnailUrl?: string;
  duration?: number;
}
